// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b2b9ff6e","732":"fbc4aef1","977":"a3ac883a"}[chunkId] + ".chunk.js";
};